<template>
  <div class="answer-area">
    <div v-show="isKittenN" class="editor" ref="kittenN"></div>
    <iframe
      v-if="editorUrl && isOperateQuestion && !isKittenN && !reloadingEditor"
      :src="editorUrl"
      class="editor"
      ref="editor"
      allow="microphone;camera;midi;encrypted-media;usb;"
    ></iframe>
    <div v-if="activeAnswer.typeId === EnumTypeId.FillSingle" class="textarea-wrap">
      <p class="name">考生答案：</p>
      <p class="answer">{{ activeAnswer.answer }}</p>
    </div>
    <div v-if="activeAnswer.questionType === EnumQuestionType.PythonUpload" class="textarea-wrap download-wrap">
      <p class="name">考生答案：</p>
      <div class="answer">
        <div class="has-answer" v-if="activeAnswer.answer">
          <icon-py-file class="icon icon-py-file"></icon-py-file>
          <p class="filename">{{ filename }}</p>
          <button class="download-btn" @click="downloadFile"><icon-download class="icon icon-download"></icon-download>考生答案下载</button>
        </div>
        <div v-else class="no-answer">
          <icon-no-answer class="icon-no-answer"></icon-no-answer>
          <p class="text">考生答案为空</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconDownload from '@/assets/svg/judge/download.svg'
import IconPyFile from '@/assets/svg/judge/py-file.svg'
import IconNoAnswer from '@/assets/svg/judge/icon-noanswer.svg'
import { downloadData } from '@/utils'
import { get } from '@/utils/ajax'
import { EnumTypeId, EnumQuestionType, Enum3DBoxType, isOperateQuestion, get3DBoxInfo, get3DBoxToken, initKittenN } from '../Test/pc/handler'
import { getWood2CatBitPayload } from '@/utils/operation-question'

export default {
  components: {
    IconDownload,
    IconPyFile,
    IconNoAnswer
  },
  props: {
    activeAnswer: {
      type: Object
    },
    activeQuesInfo: {
      type: Object
    }
  },
  data() {
    return {
      EnumTypeId,
      EnumQuestionType,
      editorUrl: '',
      filename: '',
      editorLink: '',
      blankBcm: 'https://public-static-edu.codemao.cn/eduexam/blank.bcm',
      uploadUrl: '',
      knSdk: null,
      removeToolListener: null,
      reloadingEditor: false
    }
  },
  computed: {
    isOperateQuestion() {
      return isOperateQuestion(this.activeAnswer.questionType)
    },
    isKittenN() {
      return this.activeAnswer.questionType === EnumQuestionType.KittenN
    },
    isCatbitQuestion() {
      return this.activeAnswer.questionType === EnumQuestionType.Wood2Cloud && // wood2云模式的题目
        !!this.getWood2CloudStartWork() // 存在预置文件
    }
  },
  watch: {
    async activeQuesInfo(val) {
      this.uploadUrl = val.uploadUrl
    },
    async activeAnswer(val) {
      if (isOperateQuestion(val.questionType)) { // 操作题
        switch (val.questionType) {
          case EnumQuestionType.Kitten: // kitten
            const data = await get(`/edu/exams/works/kitten/code`, {
              bcm: this.uploadUrl || this.blankBcm
            })
            const code = val.answer || data
            this.editorUrl = `${window.CONFIG.ide}?code=${code}&pid=egLIJPgY`
            break
          case EnumQuestionType.PythonUpload: // 上传文件
            this.filename = val.answer ? val.answer.split('/')[val.answer.split('/').length - 1] : ''
            break
          case EnumQuestionType.Python: // python
            const pythonUrl = window.CONFIG.python
            if (this.editorUrl === pythonUrl) {
              this.initPython()
            } else {
              this.editorUrl = pythonUrl
            }
            break
          case EnumQuestionType.Scratch: // scratch
            this.editorUrl = `${window.CONFIG.scratch}?work_url=${val.answer || this.uploadUrl}`
            break
          case EnumQuestionType.Nemo: // nemo
            this.editorUrl = `${window.CONFIG.tanyuepigai}/edu?workUrl=${encodeURIComponent(val.answer || this.uploadUrl)}`
            break
          case EnumQuestionType.Cplusplus: // c++
          case EnumQuestionType.CplusplusRealTimeOJ: // c++ 实时判题
            const cplusplusUrl = window.CONFIG.cplusplus
            if (this.editorUrl === cplusplusUrl) {
              this.initTart('cpp_oj')
            } else {
              this.editorUrl = cplusplusUrl
            }
            break
          case EnumQuestionType.PythonOJ: // Python OJ版
          case EnumQuestionType.PythonRealTimeOJ: // Python 实时判题
            const pythonOjUrl = window.CONFIG.python_oj
            if (this.editorUrl === pythonOjUrl) {
              this.initTart('py_oj')
            } else {
              this.editorUrl = pythonOjUrl
            }
            break
          case EnumQuestionType.Box3D: // 3dbox
            const info = await this.fetch3DBoxInfo()
            this.editorUrl = `${info.url}&_=${Date.now()}`
            break
          case EnumQuestionType.KittenN: // kitten_n
            if (!this.knSdk) {
              this.knSdk = await initKittenN({
                container: this.$refs.kittenN
              })
            }
            if (val.answer) {
              let url = val.answer
              try {
                url = JSON.parse(url).url
              } catch (e) {}
              this.knSdk.application.loadWork({
                work: {
                  type: 'fileUrl',
                  fileUrl: url
                }
              })
            }
            // this.editorUrl = `${window.CONFIG.kitten_n}?fileUrl=${encodeURIComponent(val.answer)}`
            break
          case EnumQuestionType.Wood2Cloud: // wood2cloud
          this.editorUrl = CONFIG.wood2_cloud
          this.reloadEditor()
            break
        }
      }
    }
  },
  mounted() {
    this.removeToolListener = this.toolListener()
  },
  destroyed() {
    if (this.removeToolListener) {
      this.removeToolListener()
    }
  },
  methods: {
    reloadEditor () {
      this.reloadingEditor = true
      this.$nextTick(() => {
        this.reloadingEditor = false
      })
    },
    toolListener () {
      const toolListenerHandler = e => {
        const message = e.data
        switch (message.msg) {
          case 'wood_is_ready':
            this.initPython()
            break
        }
        switch (message.type) {
          case 'IFRAME_READY':
            if (CONFIG.wood2_cloud.includes(e.origin)) {
              this.initWood2Cloud()
              return
            }
            this.initTart(message.payload.page)
            break
        }
        switch (message.eventType) {
          case 'cm:trans:nct:logout': // 3dbox授权token失效
            this.loading = false
            get3DBoxToken()
            this.$message.error('授权Token失效，请稍后重试')
            break
        }
      }
      window.addEventListener('message', toolListenerHandler)

      return () => {
        window.removeEventListener('message', toolListenerHandler)
      }
    },
    async initWood2Cloud () {
      const wood2CloudCode = this.activeAnswer.answer || ''
      if (!this.$refs.editor) return
      this.$refs.editor.contentWindow.postMessage(
        {
          type: 'SET_FEATURE_CONFIG',
          payload: {
            disabledFileExplorerContextMenu: false,
            disabledHeaderProjectMenu: false,
            headerProjectMenuItems: ['exportWoodProjectFile']
          }
        },
        CONFIG.wood2_cloud
      )

      let wood2CloudPayload = {
        work_id: 0,
        work_name: '新的作品',
        content: [{
          work_id: 0,
          file_id: -49,
          file_name: 'main.py',
          source: wood2CloudCode,
          open: true,
          pid: 0,
          file_type: 2
        }],
        update_time: new Date().getTime(),
        language_type: 3
      }

      if (this.isCatbitQuestion) {
        // 如果答案不存在，则获取预置文件
        if (!this.activeAnswer.answer) {
          const presetPayload = await getWood2CatBitPayload(this.getWood2CloudStartWork())
          if (presetPayload) {
            wood2CloudPayload = presetPayload
          }
        } else {
          // 小猫板的题目，答案是JSON字符串，需要解析成对象
          try {
            wood2CloudPayload = JSON.parse(wood2CloudCode)
          } catch (e) {
            // 解析失败
            console.error('解析预置文件失败', e)
          }
        }
      }
      this.$refs.editor.contentWindow.postMessage({
        type: 'SET_CURRENT_WOOD_PROJECT',
        payload: wood2CloudPayload
      }, CONFIG.wood2_cloud)
    },
    initPython () {
      if (!this.$refs.editor) return
      const python = this.$refs.editor.contentWindow
      // 设为代码模式
      python.postMessage(
        { msg: 'set_default_mode', mode: 'code' }, window.CONFIG.python
      )
      // 屏蔽切换模式按钮
      python.postMessage(
        { msg: 'set_mode_btn_display', mode: 'false' }, window.CONFIG.python
      )
      // 隐藏自带的缩放按钮
      python.postMessage(
        { msg: 'set_fullscreen_btn_display', is_display: false }, window.CONFIG.python
      )
      // 隐藏帮助按钮
      python.postMessage(
        { msg: 'set_help_btn_display', is_display: false }, window.CONFIG.python
      )
      // 打开海龟绘图
      python.postMessage(
        { msg: 'set_turtle_canvas_display', is_display: true }, window.CONFIG.python
      )
      // 设置初始化代码
      python.postMessage(
        { msg: 'set_python_code', code: `${this.activeAnswer.answer || ''}` }, window.CONFIG.python
      )
    },
    // 初始化Tart工具 type= 'py_oj' | 'cpp_oj'
    initTart(type) {
      if (!this.$refs.editor) return
      const tart = this.$refs.editor.contentWindow
      let extension = ''
      let domain = '*'
      let exportName = ''
      switch (type) {
        case 'py_oj':
          extension = 'py'
          domain = CONFIG.python_oj
          exportName = 'exportAsPythonFile'
          break
        case 'cpp_oj':
          extension = 'cpp'
          domain = CONFIG.cplusplus
          exportName = 'exportAsCppFile'
          break
        default:
          throw new Error('未知编辑器')
      }

      // 设置UI
      tart.postMessage({
        type: 'FEATURE_SET_CONFIG',
        payload: {
          headerDisabled: false, // 默认展示头部栏，true 则隐藏
          headerLogoDisabled: true, // 默认展示头部栏中的Logo，true 则隐藏
          headerFileMenuDisabled: false, // 默认展示头部栏中的文件菜单，true 则隐藏
          headerFileMenuItems: [
            // 'createProject',
            // 'openProjectManager',
            // 'workSaveAs',
            // 'divider',
            // 'openLocalFile',
            exportName
            // 'divider',
            // 'importMiaoLink',
            // 'exportAsMiaoLink',
          ], // 默认展示所有头部栏文件菜单选项，[] 则隐藏所有
          userAvatarDisabled: true, // 默认展示用户头像，true 则隐藏
          workSaveButtonDisabled: true, // 默认展示作品保存按钮，true 则隐藏
          workNameInputDisabled: true, // 默认展示作品名称输入框，true 则隐藏
          disabledRegExp: true // 默认隐藏正则配置，false 则展示
        }
      }, domain)

      // 设置答案
      tart.postMessage({
        type: 'WORK_OPEN',
        payload: {
          work: {
            work_id: 0,
            name: '新的作品',
            extension,
            content: `${this.activeAnswer.answer || ''}`,
            version: 0
          }
        }
      }, domain)
    },
    downloadFile() {
      downloadData(this.activeAnswer.answer)
    },
    // 获取3DBox地址
    async fetch3DBoxInfo() {
      if (!this.activeAnswer.answer) {
        this.$message.warning('该题考生没有作答')
        return { url: '' }
      }
      const info = await get3DBoxInfo({
        type: Enum3DBoxType.Preview,
        workId: this.activeAnswer.answer,
        title: `阅卷_${this.activeAnswer.questionId}`
      })
      return info
    },
    getWood2CloudStartWork() {
      const startWork = this.activeAnswer.startWork || this.activeAnswer.start_work
      return startWork
    }
  }
}
</script>

<style lang="scss" scoped>
  .answer-area {
    flex: 1;
    height: 100%;
  }
  .editor {
    width: 100%;
    height: 100%;
    display: inline-block;
  }
  .textarea-wrap {
    width: 100%;
    padding: 0 60px;
    .name {
      margin-top: 30px;
      font-size: 18px;
      color: #333;
    }
    .answer {
      background: rgba(56,126,253,0.03);
      border-radius: 8px;
      border: 1px solid $themeColor;
      height: 200px;
      padding: 10px 25px;
      margin-top: 20px;
      font-size: 20px;
      font-weight: 500;
      color: #333;
    }
  }
  .download-wrap {
    .icon {
      display: inline-block;
    }
    .answer {
      display: flex;
      padding-top: 45px;
    }
    .filename {
      max-width: 256px;
      @include text-ellipsis(1);
      margin: 5px 20px 0 20px;
      font-size: 16px;
    }
    .download-btn {
      width: 160px;
      height: 42px;
      border-radius: 4px;
      border: 1px solid #397EFD;
      background: rgba(56, 126, 253, 0.03);
      color: $themeColor;
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      &:hover {
        background: $themeColor;
        color: #fff;
        .icon-download {
          fill: #fff;
        }
      }
    }
    .icon-download {
      fill: $themeColor;
      margin-right: 6px;
    }
    .no-answer {
      margin: -25px auto 0 auto;
    }
    .icon-no-answer {
      display: inline-block;
    }
    .text {
      font-size: 16px;
      text-align: center;
    }
    .has-answer {
      display: flex;
    }
  }
</style>
